var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-align-justify'></i> Browse Upload Laporan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#/pengajuan/browseupload"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    attrs: {
      "role": "group"
    }
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "role": "group"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.q),
      expression: "q"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Pencarian",
      "type": "text"
    },
    domProps: {
      "value": (_vm.q)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.q = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.getBrows()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.b),
      expression: "b"
    }],
    staticClass: "form-control form-control-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.b = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getBrows()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Semua Laporan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Laporan TPS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Laporan Kawasan Pabean")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Laporan TPE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Rekonsiliasi Outward Manifes - Barkir")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "align",
      rawName: "v-align",
      value: (_vm.middle),
      expression: "middle"
    }],
    staticClass: "d-none d-sm-block",
    on: {
      "click": function($event) {
        _vm.setC('NM_PERUSAHAAN')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#/pengajuan/browseupload"
    }
  }, [_vm._v("Nama Perusahaan")])]), _vm._v(" "), _c('th', [_c('a', {
    attrs: {
      "href": "#/pengajuan/browseupload"
    },
    on: {
      "click": function($event) {
        _vm.setC('perijinan.tl_hdr.wk_kirim')
      }
    }
  }, [_vm._v("Waktu Kirim")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/pengajuan/browseupload"
    },
    on: {
      "click": function($event) {
        _vm.setC('perijinan.tl_hdr.tgl_awal')
      }
    }
  }, [_vm._v("Tanggal Awal")])]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_c('a', {
    attrs: {
      "href": "#/pengajuan/browseupload"
    },
    on: {
      "click": function($event) {
        _vm.setC('perijinan.tl_hdr.tgl_akhir')
      }
    }
  }, [_vm._v("Tanggal Akhir")])]), _vm._v(" "), _c('th', [_c('a', {
    attrs: {
      "href": "#/pengajuan/browseupload"
    },
    on: {
      "click": function($event) {
        _vm.setC('perijinan.tl_hdr.jns_laporan')
      }
    }
  }, [_vm._v("Jenis Laporan")])]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.brows.data), function(brow) {
    return _c('tr', [_c('td', {
      staticClass: "d-none d-sm-block"
    }, [_vm._v(_vm._s(brow.NM_PERUSAHAAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.wk_rekam) + " " + _vm._s(brow.wk_kirim))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.tgl_awal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.tgl_akhir))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.jenis))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-success",
      attrs: {
        "title": "Download",
        "href": _vm.$http.options.root + '/unduh/' + brow.id_tl_hdr + '/' + brow.nm_file
      },
      on: {
        "click": function($event) {}
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.getData(brow.id_tl_hdr, brow.jns_laporan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.first_page_url)
      }
    }
  }, [_vm._v("\n            «\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.prev_page_url)
      }
    }
  }, [_vm._v("\n            ‹\n          ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.p),
      expression: "p"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "placeholder": _vm.brows.current_page + '/' + _vm.brows.last_page,
      "type": "text",
      "size": "2"
    },
    domProps: {
      "value": (_vm.p)
    },
    on: {
      "change": function($event) {
        _vm.getBrows('bc/brows/browslist?page=' + _vm.p)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.p = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.next_page_url)
      }
    }
  }, [_vm._v("\n            ›\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.last_page_url)
      }
    }
  }, [_vm._v("\n            »\n          ")])])])]), _vm._v(" "), _c('b-modal', {
    staticClass: "modal-warning",
    attrs: {
      "hide-footer": "",
      "title": "Laporan",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.modaldata = false
      }
    },
    model: {
      value: (_vm.modaldata),
      callback: function($$v) {
        _vm.modaldata = $$v
      },
      expression: "modaldata"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    staticStyle: {
      "height": "500px",
      "max-width": "800px",
      "overflow-y": "scroll",
      "overflow-x": "scroll"
    }
  }, [(_vm.jenis == 1) ? _c('table', {
    staticClass: "table table-bordered table-hover table-sm"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("BC 1.0")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("BC 1.1")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("B/L / AWB")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Shipper")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Consignee")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Jumlah")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(" Lokasi Timbun (Gudang / Lapangan)")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(" No. Kontainer")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" Waktu (Masuk)")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(" No. Segel")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" Waktu (Keluar)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Dok. Pengeluaran")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Keterangan")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Pos")]), _vm._v(" "), _c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Container")]), _vm._v(" "), _c('th', [_vm._v("Kemasan")]), _vm._v(" "), _c('th', [_vm._v("Bruto")]), _vm._v(" "), _c('th', [_vm._v("Volume")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Jam")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Jam")]), _vm._v(" "), _c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")])]), _vm._v(" "), _vm._l((_vm.daftar), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_bc10))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tgl_bc10))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_bc11))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tgl_bc11))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_pos))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_bl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tgl_bl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipper))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.consignee))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.jml_cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.jml_kemasan) + " " + _vm._s(data.kd_kemasan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.brutto))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.volume))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.id_gudang))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tgl_masuk))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.jam_masuk))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_segel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tgl_keluar))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.jam_keluar))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_dok_keluar))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tgl_dok_keluar))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.keterangan))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.jenis == 2) ? _c('table', {
    staticClass: "table table-bordered table-hover table-sm"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("BC 1.0")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Nama Sarana Pengangkut")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("No. Voy")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Bendera")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Pelabuhan")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Waktu Kedatangan / Keberangkatan")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Jumlah")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Agen Pengangkut")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("BC 1.1 (Inward)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("BC 1.1 (Outward)")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Keterangan")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Asal")]), _vm._v(" "), _c('th', [_vm._v("Tujuan")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Jam")]), _vm._v(" "), _c('th', [_vm._v("Kontainer")]), _vm._v(" "), _c('th', [_vm._v("Kemasan")]), _vm._v(" "), _c('th', [_vm._v("Bruto")]), _vm._v(" "), _c('th', [_vm._v("Volume")]), _vm._v(" "), _c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")])]), _vm._v(" "), _vm._l((_vm.daftar), function(data2, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.no_bc10))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.tgl_bc10))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.nm_sarkut))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.no_voy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.bendera))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.pel_asal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.pel_tujuan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.tgl_tiba))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.jam_tiba))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.jml_cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.jml_kemasan) + " " + _vm._s(data2.kd_kemasan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.bruto))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.volume))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.agen_pengangkut))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.no_bc11_in))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.tgl_bc11_in))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.no_bc11_out))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.tgl_bc11_out))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.keterangan))])])
  })], 2) : _vm._e()])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d75ebb0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Brows/browseupload.vue
// module id = 299
// module chunks = 0